export const faqs = [
  {
    q: "When can I re-apply after a 214(b) refusal?",
    a: "There's no mandatory waiting period - technically you can re-apply the next day. But re-applying without fixing the underlying reason is the fastest way to a second refusal. We recommend 4–8 weeks of focused prep so something has materially changed in your profile or story.",
  },
  {
    q: "Can you guarantee my visa will be approved on the re-attempt?",
    a: "No honest Specialist can guarantee a visa - the decision is the officer's. What we guarantee is that you'll walk in with a clean DS-160, a tight story, an answer for every red flag, and the calmness that comes from 5 hard mocks. That's what moves the odds.",
  },
  {
    q: "How is this different from your Full Support plan?",
    a: "Full Support is for first-timers. Refusal Support adds a root-cause analysis of your last interview and red-flag remediation - the two things that decide a re-attempt. You also get one extra mock (5 instead of 4) because the difficulty curve is steeper.",
  },
  {
    q: "I was refused at a different consulate. Can I switch cities?",
    a: "Yes, you can choose any US consulate in your country of residence. We'll discuss whether switching makes sense based on your specific case - sometimes it helps, sometimes it doesn't.",
  },
  {
    q: "What if I was refused more than once?",
    a: "We've worked with applicants on their 3rd and 4th attempts. The work is the same - the analysis just goes deeper. Message us on WhatsApp first so we can scope properly before you enroll.",
  },
];
